<div class="card border-0 shadow-sm pt-0 mb-4">
    <div class="card-header fs-5 fw-medium">Compliance Manager Section</div>
    <div class="card-body">
        <div class="row g-3">
            <div class="col-md-3">
                <label class="form-label">Is a CPAR needed?: </label>
                <dx-select-box [(value)]="incidentReport.isCparRequired" [items]="yesOrNoOptions" valueExpr="value"
                    displayExpr="text" stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly">
                </dx-select-box>
            </div>
            <div class="col-md-3">
                <label class="form-label">CPAR Tracking Number #: </label>
                <dx-text-box stylingMode="filled" [(value)]="incidentReport.cparTrackingNumber" maxLength="100"
                    placeholder="Enter CPAR tracking number" [readOnly]="isReadOnly">
                </dx-text-box>
            </div>
            <div class="col-md-3">
                <label class="form-label">Risk Assessment reviewed by: </label>
                <dx-text-box stylingMode="filled" [(value)]="incidentReport.riskAssessmentReviewedBy" maxLength="100"
                    placeholder="Enter name of person who reviewed risk assessment" [readOnly]="isReadOnly">
                </dx-text-box>
            </div>
            <div class="col-md-3">
                <label class="form-label">Risk Assessment reviewed (date): </label>
                <dx-date-box [(value)]="incidentReport.riskAssessmentReviewedDate" stylingMode="filled"
                    [useMaskBehavior]="true" [displayFormat]="dateFormat" [readOnly]="isReadOnly">
                </dx-date-box>
            </div>
        </div>
        <div class="row mt-1 g-3">
            <div class="col-md-4">
                <label class="form-label">No Changes Needed: </label>
                <dx-select-box [(value)]="incidentReport.isCparChangesRequired" [items]="yesOrNoOptions"
                    valueExpr="value" displayExpr="text" stylingMode="filled" placeholder="Select..."
                    [readOnly]="isReadOnly">
                </dx-select-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Could this occur elsewhere?: </label>
                <dx-select-box [(value)]="incidentReport.couldOccurElsewhere" [items]="yesOrNoOptions" valueExpr="value"
                    displayExpr="text" stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly">
                </dx-select-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Was Food Safety impacted?: </label>
                <dx-select-box [(value)]="incidentReport.wasFoodSafetyImpacted" [items]="yesOrNoOptions"
                    valueExpr="value" displayExpr="text" stylingMode="filled" placeholder="Select..."
                    [readOnly]="isReadOnly">
                </dx-select-box>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <label class="form-label">Details (if Food Safety impacted):</label>
                <dx-text-area [(value)]="incidentReport.foodSafetyImpactDetails" stylingMode="filled" [height]="80"
                    placeholder="Food safety impact details..." [maxLength]="2000" [readOnly]="isReadOnly">
                </dx-text-area>
            </div>
        </div>
        <div class="row mt-3 g-3">
            <div class="col-md-6">
                <label class="form-label">Hazard Type:</label>
                <div class="d-flex flex-column gap-2 mt-2">
                    <dx-check-box [(value)]="incidentReport.isSafetyHazard" text="Safety"
                        [readOnly]="isReadOnly"></dx-check-box>
                    <dx-check-box [(value)]="incidentReport.isHealthHazard" text="Health"
                        [readOnly]="isReadOnly"></dx-check-box>
                    <dx-check-box [(value)]="incidentReport.isEnvironmentalHazard" text="Environmental"
                        [readOnly]="isReadOnly"></dx-check-box>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mb-3">
                    <div class="mb-3">
                        <label class="form-label">Aspects & Impacts reviewed: </label>
                        <dx-text-box stylingMode="filled" [(value)]="incidentReport.aspectsAndImpactsReviewedBy"
                            maxLength="100" placeholder="Enter aspects & impacts reviewed by" [readOnly]="isReadOnly">
                        </dx-text-box>
                    </div>
                    <div>
                        <label class="form-label">No Changes Needed: </label>
                        <dx-select-box [(value)]="incidentReport.areAspectChangesRequired" [items]="yesOrNoOptions"
                            valueExpr="value" displayExpr="text" stylingMode="filled" placeholder="Select..."
                            [readOnly]="isReadOnly">
                        </dx-select-box>
                    </div>
                </div>
            </div>
        </div>
        <hr class="section-divider">
        <div class="form-section mt-3">
            <div class="header-text">Risk Criteria</div>
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">Probability Criteria: </label>
                    <dx-text-box stylingMode="filled" [(value)]="incidentReport.probabilityCriteria" maxLength="100"
                        placeholder="Enter probability criteria" [readOnly]="isReadOnly">
                    </dx-text-box>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Severity Criteria: </label>
                    <dx-text-box stylingMode="filled" [(value)]="incidentReport.severityCriteria" maxLength="100"
                        placeholder="Enter severity criteria" [readOnly]="isReadOnly">
                    </dx-text-box>
                </div>
            </div>
        </div>
        <div class="row mt-1 g-3">
            <div class="col-md-4">
                <label class="form-label">Legal & Other Requirements reviewed: </label>
                <dx-text-box stylingMode="filled" [(value)]="incidentReport.legalRequirementsReviewedBy" maxLength="100"
                    placeholder="Enter legal & other requirements reviewed" [readOnly]="isReadOnly">
                </dx-text-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">No Changes Needed: </label>
                <dx-select-box [(value)]="incidentReport.areLegalRequirementChangesRequired" [items]="yesOrNoOptions"
                    valueExpr="value" displayExpr="text" stylingMode="filled" placeholder="Select..."
                    [readOnly]="isReadOnly">
                </dx-select-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Risk Ranking </label>
                <dx-text-box stylingMode="filled" [(value)]="incidentReport.riskRanking" maxLength="100"
                    placeholder="Enter risk ranking" [readOnly]="isReadOnly">
                </dx-text-box>
            </div>
        </div>
    </div>
</div>